import { jsx as _jsx } from "react/jsx-runtime";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { TextBody, TextHeading } from '../text/index.js';
import { linkStyle } from '../../shared-styles/link.css.js';
/**
 * Convert markdown to styled text
 */
export const Markdown = ({ content, paragraphSize = 'medium', paragraphSpacing, stopLinkPropagation = false, }) => {
    return (_jsx(ReactMarkdown, { remarkPlugins: [remarkGfm], components: {
            h1: ({ children }) => (_jsx(TextHeading, { tag: "h1", size: "large", children: children })),
            h2: ({ children }) => (_jsx(TextHeading, { tag: "h2", size: "medium", children: children })),
            h3: ({ children }) => (_jsx(TextHeading, { tag: "h3", size: "small", children: children })),
            h4: ({ children }) => (_jsx(TextHeading, { tag: "h4", size: "xsmall", children: children })),
            p: ({ children }) => (_jsx(TextBody, { spacing: paragraphSpacing, size: paragraphSize, children: children })),
            a: ({ children, href }) => (_jsx("a", { href: href, className: linkStyle({
                    color: 'default',
                    weight: 'semibold',
                    underline: false,
                }), target: "_blank", rel: "noopener noreferrer", onClick: (e) => {
                    if (stopLinkPropagation) {
                        e.stopPropagation();
                    }
                }, children: children })),
        }, children: content }));
};
